import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sidenav, Nav, Dropdown } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'
import Swal from 'sweetalert2'
import * as FaIcons from 'react-icons/fa';
import logo from '../../../../images/LAPELS-LOLA-Logo.png'
import { useState } from 'react';

function Sidebar(props) {
    const [activeKey, setActiveKey] = React.useState();
    const [showBoardSection, setShowBoardSection] = useState(false);
    useEffect(() => {
        setShowBoardSection(props.isBoardMember);
        if (props.activeKey) {
            setActiveKey(props.activeKey);
        } else {
            var key = sessionStorage.getItem("currentSideNavKey");
            if (key) {
                setActiveKey(key);
            }
            else {
                if (props.isBoardMember) {
                    setActiveKey("8");
                    sessionStorage.setItem("currentSideNavKey", "8");
                }
                else {
                    setActiveKey("1");
                    sessionStorage.setItem("currentSideNavKey", "1");
                }
            }
        }
    }, [])
    const onSelect = (e) => {
        setActiveKey(e);
        sessionStorage.setItem("currentSideNavKey", e);
    }
    return (
        <div className='sidenav'>
            <Sidenav activeKey={activeKey} onSelect={onSelect} expanded={props.expanded}>
                <Sidenav.Header>
                    <div className='heads'>
                        <img src={logo} alt="Louisiana State Seal" style={{ width: props.expanded ? '60px' : '40px' }} />
                        {props.expanded &&
                            <b> LOLA</b>
                        }
                    </div>
                </Sidenav.Header>
                <Sidenav.Body>
                    <Nav>
                        {showBoardSection &&
                            <Nav.Item eventKey="8" icon={<FaIcons.FaClipboardCheck size="2x" className="rs-icon sideBarIcon" />} as={Link} to="/individual/boardApprovals">
                                Board Approvals
                            </Nav.Item>
                        }
                        <Nav.Item eventKey="1" icon={<FaIcons.FaTh className="rs-icon sideBarIcon" />} as={Link} to="/individual/dashboard">
                            Dashboard
                        </Nav.Item>
                        <Nav.Item eventKey="2" icon={<FaIcons.FaIdCard className="rs-icon sideBarIcon" />} as={Link} to="/individual/contactinformation">
                            Update contact information
                        </Nav.Item>
                        <Nav.Item eventKey="3" icon={<FaIcons.FaClipboardList className="rs-icon sideBarIcon" />} as={Link} to="/individual/applications/">
                            Apply for a license/certification
                        </Nav.Item>
                        <Nav.Item eventKey="4" icon={<FaIcons.FaCertificate className="rs-icon sideBarIcon" />} as={Link} to="/individual/renewals/">
                            Renew a license/certification
                        </Nav.Item>
                        <Nav.Item eventKey="5" icon={<FaIcons.FaSyncAlt className="rs-icon sideBarIcon" />} as={Link} to="/individual/reinstatements/">
                            Reinstate a license/certification
                        </Nav.Item>
                        <Nav.Item eventKey="6" icon={<FaIcons.FaUsers className="rs-icon sideBarIcon" />} as={Link} target="_blank" to="/individual/supervisingprofessional">
                            Supervising Professional (SP) Locker
                        </Nav.Item>
                        <Nav.Item eventKey="7" icon={<FaIcons.FaListAlt className="rs-icon sideBarIcon" />} as={Link} to="/individual/cpdlocker">
                            CPD Locker
                        </Nav.Item>
                        <Dropdown eventKey="9" title="Other Online Services" icon={<FaIcons.FaToolbox className="rs-icon sideBarIcon" />}>
                            <Dropdown.Item href="https://www.lapels.com/quiz" target="_blank" eventKey="8-1">Online Quizzes</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/indivsearch" target="_blank" eventKey="8-2">Individual Search</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/firmsearch" target="_blank" eventKey="8-3">Firm Search</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/contact.html" target="_blank" eventKey="8-4">Contact Us</Dropdown.Item>
                            <Dropdown.Item href="https://www.google.com/maps/place/8550+United+Plaza+Blvd+Suite+903,+Baton+Rouge,+LA+70809/@30.4116425,-91.0994727,17z/data=!3m1!4b1!4m6!3m5!1s0x8626a48a786d3579:0x6dc2a640e72697a5!8m2!3d30.4116425!4d-91.0968978!16s%2Fg%2F11rzfxkjh9?hl=en&entry=ttu&g_ep=EgoyMDI1MDIxOS4xIKXMDSoASAFQAw%3D%3D" target="_blank" eventKey="8-5">Directions to LAPELS</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/LawsRules.html" target="_blank" eventKey="8-6">Laws and Rules</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/board_meeting.html" target="_blank" eventKey="8-7">Board Meetings</Dropdown.Item>
                        </Dropdown>
                    </Nav>
                </Sidenav.Body>
            </Sidenav>
        </div>
    );
}

export default Sidebar;
